module.exports = __webpack_public_path__ + "static/media/notificacion_categoria_acciones.8cd7a647.png";